// eslint-disable-next-line ember/no-classic-components
import Component from '@ember/component';

export default class DashboardProductBoxPercentageComponent extends Component {
  tagName = '';
}
